var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "field-selector" }, [
    _c("div", { staticClass: "field-group primitive-fields" }, [
      _c("div", { staticClass: "group-title" }, [
        _vm._v(_vm._s(_vm.$t("table.primitiveFields"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "group-content" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipText") },
                expression: "{ content: $t('table.fsTooltipText') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("text")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("text_fields")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.text")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipLongText") },
                expression: "{ content: $t('table.fsTooltipLongText') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("long-text")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("subject")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.longText")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipNumber") },
                expression: "{ content: $t('table.fsTooltipNumber') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("number")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("looks_one")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.number")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipCurrency") },
                expression: "{ content: $t('table.fsTooltipCurrency') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("currency")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("attach_money"),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.currency")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipDatetime") },
                expression: "{ content: $t('table.fsTooltipDatetime') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("datetime")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("event")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.datetime")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipDropdown") },
                expression: "{ content: $t('table.fsTooltipDropdown') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("dropdown")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("arrow_drop_down"),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.dropdown")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipCheckbox") },
                expression: "{ content: $t('table.fsTooltipCheckbox') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("checkbox")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("check_box")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.checkbox")))]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field-group validator-fields" }, [
      _c("div", { staticClass: "group-title" }, [
        _vm._v(_vm._s(_vm.$t("table.validatorFields"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "group-content" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipUrl") },
                expression: "{ content: $t('table.fsTooltipUrl') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("url")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("link")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("table.fsLabelUrl")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipEmail") },
                expression: "{ content: $t('table.fsTooltipEmail') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("email")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("email")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.email")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipPhone") },
                expression: "{ content: $t('table.fsTooltipPhone') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("phone")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("phone")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.phone")))]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field-group module-fields" }, [
      _c("div", { staticClass: "group-title" }, [
        _vm._v(_vm._s(_vm.$t("table.moduleFields"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "group-content" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipContact") },
                expression: "{ content: $t('table.fsTooltipContact') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("contact")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("person")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("modules.contact")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipTicket") },
                expression: "{ content: $t('table.fsTooltipTicket') }",
              },
            ],
            staticClass: "field-item not-implemented",
            on: {
              click: function ($event) {
                return _vm.selectField("ticket")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("confirmation_number"),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("message.ticket")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipTask") },
                expression: "{ content: $t('table.fsTooltipTask') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("task")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("assignment")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("message.task")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipEvent") },
                expression: "{ content: $t('table.fsTooltipEvent') }",
              },
            ],
            staticClass: "field-item not-implemented",
            on: {
              click: function ($event) {
                return _vm.selectField("event")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("event")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("message.event")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipUser") },
                expression: "{ content: $t('table.fsTooltipUser') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("user")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("support_agent"),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("message.user")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipConversation") },
                expression: "{ content: $t('table.fsTooltipConversation') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("conversation")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("message")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("tables.linkedFieldConversation"))),
            ]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field-group metadata-fields" }, [
      _c("div", { staticClass: "group-title" }, [
        _vm._v(_vm._s(_vm.$t("table.metaFields"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "group-content" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.metaFieldRecordIdTooltip") },
                expression: "{ content: $t('table.metaFieldRecordIdTooltip') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("record_id")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("tag")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("table.metaFieldRecordId")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content: _vm.$t("table.metaFieldRecordCreatedAtTooltip"),
                },
                expression:
                  "{ content: $t('table.metaFieldRecordCreatedAtTooltip') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("record_created_at")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("add_circle_outline"),
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("table.metaFieldRecordCreatedAt"))),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content: _vm.$t("table.metaFieldRecordUpdatedAtTooltip"),
                },
                expression:
                  "{ content: $t('table.metaFieldRecordUpdatedAtTooltip') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("record_updated_at")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("update")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("table.metaFieldRecordUpdatedAt"))),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content: _vm.$t("table.metaFieldRecordCreatedByTooltip"),
                },
                expression:
                  "{ content: $t('table.metaFieldRecordCreatedByTooltip') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("record_created_by")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("person_add")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("table.metaFieldRecordCreatedBy"))),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content: _vm.$t("table.metaFieldRecordUpdatedByTooltip"),
                },
                expression:
                  "{ content: $t('table.metaFieldRecordUpdatedByTooltip') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("record_updated_by")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("person_outline"),
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("table.metaFieldRecordUpdatedBy"))),
            ]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field-group file-fields" }, [
      _c("div", { staticClass: "group-title" }, [
        _vm._v(_vm._s(_vm.$t("table.fileFields"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "group-content" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipFile") },
                expression: "{ content: $t('table.fsTooltipFile') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("file")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("attachment")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.file")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipImage") },
                expression: "{ content: $t('table.fsTooltipImage') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("image")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("image")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.image")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipVideo") },
                expression: "{ content: $t('table.fsTooltipVideo') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("video")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("videocam")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.video")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipAudio") },
                expression: "{ content: $t('table.fsTooltipAudio') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("audio")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("audiotrack")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.audio")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipMultiFile") },
                expression: "{ content: $t('table.fsTooltipMultiFile') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("multi-file")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("folder")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.multiFile")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipMultiImage") },
                expression: "{ content: $t('table.fsTooltipMultiImage') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("multi-image")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("photo_library"),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.multiImage")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipMultiVideo") },
                expression: "{ content: $t('table.fsTooltipMultiVideo') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("multi-video")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("video_library"),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.multiVideo")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { content: _vm.$t("table.fsTooltipMultiAudio") },
                expression: "{ content: $t('table.fsTooltipMultiAudio') }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("multi-audio")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("library_music"),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.multiAudio")))]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field-group special-fields" }, [
      _c("div", { staticClass: "group-title" }, [
        _vm._v(_vm._s(_vm.$t("table.specialFields"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "group-content" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { content: _vm.$t("table.fsTooltipAi") },
                  expression: "{ content: $t('table.fsTooltipAi') }",
                },
              ],
              staticClass: "field-item",
              on: {
                click: function ($event) {
                  return _vm.selectField("ai")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("auto_awesome"),
              ]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("table.fsLabelAiField")))]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { content: _vm.$t("table.fsTooltipFormula") },
                  expression: "{ content: $t('table.fsTooltipFormula') }",
                },
              ],
              staticClass: "field-item",
              on: {
                click: function ($event) {
                  return _vm.selectField("formula")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("functions")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("table.fsLabelFormula")))]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { content: _vm.$t("table.fsTooltipLookup") },
                  expression: "{ content: $t('table.fsTooltipLookup') }",
                },
              ],
              staticClass: "field-item",
              on: {
                click: function ($event) {
                  return _vm.selectField("lookup")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("sync_alt")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("table.fsLabelLookup")))]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { content: _vm.$t("table.fsTooltipAutoIncrement") },
                  expression: "{ content: $t('table.fsTooltipAutoIncrement') }",
                },
              ],
              staticClass: "field-item",
              on: {
                click: function ($event) {
                  return _vm.selectField("auto-increment")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("plus_one")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("table.fsLabelAutoIncrement"))),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "PermissionController",
            {
              attrs: {
                permissions: ["automation.get", "table.update"],
                controller: "every",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "field-item",
                  on: { click: _vm.createAutomationButton },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("smart_button"),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("tables.automationButton"))),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { content: _vm.$t("table.fsTooltipLinkedRecord") },
                  expression: "{ content: $t('table.fsTooltipLinkedRecord') }",
                },
              ],
              staticClass: "field-item",
              on: {
                click: function ($event) {
                  return _vm.selectField("linked-record")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("switch_access_shortcut"),
              ]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("table.fsLabelLinkedRecord")))]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { content: _vm.$t("table.fsTooltipJson") },
                  expression: "{ content: $t('table.fsTooltipJson') }",
                },
              ],
              staticClass: "field-item",
              on: {
                click: function ($event) {
                  return _vm.selectField("json")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("code")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("table.fsLabelJson")))]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { content: _vm.$t("table.fsTooltipColor") },
                  expression: "{ content: $t('table.fsTooltipColor') }",
                },
              ],
              staticClass: "field-item",
              on: {
                click: function ($event) {
                  return _vm.selectField("color")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("palette")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("tables.color")))]),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }